// extracted by mini-css-extract-plugin
export default {"riskBanner":"RiskBanner_riskBanner__a51tF"};